export default {
  landscape: "landscape",
  portrait: "portrait",
};
